import { noop } from "@client/shared/constants";
import Service from "../service";

import { USER_CONFIG_STORAGE_KEY } from "@client/shared/constants";
import WarningModule from "./view";

export default function WarningDialog({
  isOpen = false,
  onClose = noop,
  content = "",
  handleDelete = noop,
  isButtonLoading = false,
  userData = {},
  userPreference = false,
  positiveLabel = "Delete",
  negativeLabel = "Cancel",
  preferenceName = "deletePreference",
}) {
  const patchPreference = async (preference) => {
    const { error } = await Service.setUserPreference(userData.id, {
      [preferenceName]: preference,
    });
    if (error) {
      return;
    } else {
      localStorage.setItem(
        USER_CONFIG_STORAGE_KEY,
        JSON.stringify({ user: { ...userData, [preferenceName]: preference } })
      );
    }
  };
  return (
    <WarningModule
      isOpen={isOpen}
      onClose={onClose}
      handleDelete={handleDelete}
      content={content}
      userPreference={userPreference}
      patchPreference={(preference) => patchPreference(preference)}
      isButtonLoading={isButtonLoading}
      positiveLabel={positiveLabel}
      negativeLabel={negativeLabel}
    />
  );
}
